var map = {
	"./button-hover.png": 27,
	"./button-hover@2x.png": 28
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/button\-hover.*\.png$
// module id = 190
// module chunks = 3